import DELETE from './api/delete'
import GET from './api/get'

export default {
  DELETE,
  GET
}
